import classNames from "classnames"
import { FC, ReactNode } from "react"
import { createPortal } from "react-dom"
import Icon from "./Icon"

type Props = {
  children?: ReactNode
  className?: string
  close(): void
  onClose?(): void
  title?: ReactNode
}

const Modal: FC<Props> = ({
  children,
  className,
  close,
  onClose,
  title
}) => {
  const closeModal = (): void => {
    close()
    if (onClose) {
      onClose()
    }
  }

  return createPortal(
    <>
      <div onClick={closeModal} className="modal__background" />

      <div className={classNames("modal__wrapper", className)}>
        <div className="modal__header">
          <div className="modal__header-title">{title}</div>
          <span onClick={closeModal} className="modal__header-x-close">
            <Icon name="x-close" size={30}/>
          </span>
        </div>

        <div className="modal__body">
          {children}
        </div>
      </div>
    </>,
    document.body
  )
}

export default Modal
